export default {"src":"/_next/static/media/apple.b31f197b.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};